import { queryOptions } from '@tanstack/react-query';

import type { Package } from '@/integrations/revenuecat/types';

import { getAvailablePackages } from './getAvailablePackages';

export const availablePackagesKey = () => ['available-packages'] as const;

export const availablePackagesOptions = () =>
  queryOptions<Package[]>({
    queryKey: availablePackagesKey(),
    queryFn: getAvailablePackages,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
